import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import { fetchPosLocationOptions as fetchPosLocationOptionsRoutine } from './routines';

export const fetchPosLocationOptions = () =>
  sagaRoutineRequest(fetchPosLocationOptionsRoutine, {
    request: () => call(Api.fetchInventoryLocationOptions)
  });
